// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"151":"4f56c430","284":"128abfa9"}[chunkId] + ".css";
};